"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unescapedText = exports.text = exports.formatDateTime = exports.abbreviateNumber = exports.parseNumber = exports.formatNumber = exports.formatPercentage = exports.formatCurrency = exports.formatName = exports.getLang = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _getLang = _interopRequireDefault(require("./getLang"));

var _formatName = _interopRequireDefault(require("./formatName"));

var _unescapedText = _interopRequireDefault(require("./unescapedText"));

console.warn('Do not import from I18n/utils. Import the function directly or use the equivalent method on the I18n object.');
var getLang = _getLang.default;
exports.getLang = getLang;
var formatName = _formatName.default;
exports.formatName = formatName;
var formatCurrency = _I18n.default.formatCurrency;
exports.formatCurrency = formatCurrency;
var formatPercentage = _I18n.default.formatPercentage;
exports.formatPercentage = formatPercentage;
var formatNumber = _I18n.default.formatNumber;
exports.formatNumber = formatNumber;
var parseNumber = _I18n.default.parseNumber;
exports.parseNumber = parseNumber;
var abbreviateNumber = _I18n.default.abbreviateNumber;
exports.abbreviateNumber = abbreviateNumber;
var formatDateTime = _I18n.default.moment;
exports.formatDateTime = formatDateTime;
var text = _I18n.default.text;
exports.text = text;
var unescapedText = _unescapedText.default;
exports.unescapedText = unescapedText;